import { useCallback, useEffect } from "react";
import { connect } from "react-redux";
import Section from "../../common/section";
import {
  learningMilestoneCountSummaryRequest,
  learningMilestoneItemSummaryRequest,
  learningMilestoneUsersRequest,
  setLearningMilestoneQuery,
  learningMilestoneUserExcelRequest,
} from "../../../store/slices/selfSlice";
import LearningStatusSummary from "./widgets/LearningStatusSummary";
import LearningItemSummary from "./widgets/LearningItemSummary";
import LearningUsersSummary from "./widgets/LearningUsersSummary";
import { Button } from "primereact/button";
import DropdownButton from "../../common/dropDownButton";
import { useIntl } from "react-intl";

const LearningMilestoneReport = ({
  filters = [],
  additionalQuery = {},
  learningMilestones,
  loadLearningMilestoneCountSummary,
  loadLearningMilestoneItemSummary,
  loadLearningMilestoneUsers,
  setLearningMilestoneQuery,
  loadLearningMilestoneUserExcel,
}) => {
  const intl = useIntl();

  const fetchReports = useCallback(() => {
    const payloadFilters = [];

    loadLearningMilestoneCountSummary({
      query: additionalQuery,
      filters: payloadFilters,
    });
    loadLearningMilestoneItemSummary({
      query: additionalQuery,
      filters: payloadFilters,
    });
  }, [
    loadLearningMilestoneCountSummary,
    loadLearningMilestoneItemSummary,
    setLearningMilestoneQuery,
    additionalQuery,
  ]);

  const fetchUserList = useCallback(() => {
    const payloadFilters = [];
    loadLearningMilestoneUsers({
      query: {
        ...learningMilestones.query,
        ...additionalQuery,
      },
      filters: payloadFilters,
    });
  }, [learningMilestones.query, additionalQuery]);

  useEffect(() => {
    fetchReports();
  }, [fetchReports]);

  useEffect(() => {
    fetchUserList();
  }, [fetchUserList]);

  const exportReport = (fileType = "excel") => {
    loadLearningMilestoneUserExcel({
      fileType,
      query: {
        ...learningMilestones.query,
        ...additionalQuery,
      },
      filters: filters
        .filter((item) => item.values.length > 0)
        .map((item) => ({
          id: item.id,
          values: item.values,
          isDynamicField:
            item.id !== "Designation" &&
            item.id !== "Department" &&
            item.id !== "ManagerId",
        })),
    });
  };

  return (
    <div className="grid">
      <div className="col-12 md:col-4">
        <Section title="summary">
          <LearningStatusSummary
            loading={learningMilestones?.countSummary === null}
            data={learningMilestones?.countSummary || []}
          />
        </Section>
      </div>
      <div className="col-12 md:col-8">
        <Section title="by_learning_Milestones">
          <LearningItemSummary
            loading={learningMilestones?.itemSummary === null}
            data={learningMilestones?.itemSummary || []}
          />
        </Section>
      </div>
      <div className="col-12">
        <Section title="details">
          <div
            className="flex justify-content-end"
            style={{ marginBottom: 10 }}
          >
            <DropdownButton
              icon="pi pi-download"
              label={intl.formatMessage({ id: "export" })}
              items={[
                {
                  label: intl.formatMessage({ id: "excel" }),
                  command: () => exportReport("excel"),
                },
                {
                  label: intl.formatMessage({ id: "csv" }),
                  command: () => exportReport("csv"),
                },
                {
                  label: intl.formatMessage({ id: "pdf" }),
                  command: () => exportReport("pdf"),
                },
              ]}
            />
          </div>
          <LearningUsersSummary
            learningName="learning_milestone"
            loading={learningMilestones?.list?.list === null}
            data={learningMilestones?.list?.list || []}
            totalRecords={learningMilestones?.list?.totalCount || 0}
            query={learningMilestones.query || {}}
            setQuery={setLearningMilestoneQuery}
          />
        </Section>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  learningMilestones: state.self?.myteam?.learningMilestones || {},
});

const mapDispatchToProps = (dispatch) => ({
  loadLearningMilestoneCountSummary: (data) =>
    dispatch(learningMilestoneCountSummaryRequest(data)),
  loadLearningMilestoneItemSummary: (data) =>
    dispatch(learningMilestoneItemSummaryRequest(data)),
  loadLearningMilestoneUsers: (data) =>
    dispatch(learningMilestoneUsersRequest(data)),
  setLearningMilestoneQuery: (data) =>
    dispatch(setLearningMilestoneQuery(data)),
  loadLearningMilestoneUserExcel: (data) =>
    dispatch(learningMilestoneUserExcelRequest(data)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LearningMilestoneReport);
